import Cookies from "js-cookie";
import { clearCachedBranding } from "../app/theme/applyBrand";

export const setCookie = (key: string, value: string, options: any = {}) => {
  const cookieDomain = window.location.hostname || "";

  const defaultOptions = {
    path: "/",
    secure: true,
    sameSite: "Lax",
    domain: cookieDomain,
    ...options,
  };

  Cookies.set(key, value, defaultOptions);
};

export const removeCookie = (key: string) => {
  const cookieDomain = window.location.hostname || "";

  Cookies.remove(key, {
    path: "/",
    domain: cookieDomain,
  });

  // Drop the cached branding alongside the session, so the next user on this device does not
  // see a flash of the previous organization's colours before their own resolve completes.
  if (key === "auth_token") {
    clearCachedBranding();
  }
};
